"use client";

import { useState, useEffect } from 'react';
import { Share2, Copy, Check } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useToast } from '@/hooks/use-toast';
import { Tooltip, TooltipProvider, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip';

export function ShareButton() {
  const [hasCopied, setHasCopied] = useState(false);
  const [pageUrl, setPageUrl] = useState('');
  const { toast } = useToast();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setPageUrl(window.location.href);
    }
  }, []);

  const handleCopy = () => {
    navigator.clipboard.writeText(pageUrl);
    setHasCopied(true);
    toast({
      title: 'Link Copied!',
      description: 'The page URL has been copied to your clipboard.',
    });
    setTimeout(() => setHasCopied(false), 2500);
  };

  return (
    <TooltipProvider delayDuration={100}>
        <Tooltip>
            <TooltipTrigger asChild>
                <Button variant="ghost" size="icon" onClick={handleCopy} aria-label="Copy link">
                    {hasCopied ? <Check className="h-5 w-5 text-green-500" /> : <Share2 className="h-5 w-5" />}
                </Button>
            </TooltipTrigger>
            <TooltipContent>
                <p>{hasCopied ? 'Copied!' : 'Copy Link'}</p>
            </TooltipContent>
        </Tooltip>
    </TooltipProvider>
  );
}
